"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIMULATED_PERSON_AUDIT_EVENT_TYPES = void 0;
const enums_1 = require("../enums");
exports.SIMULATED_PERSON_AUDIT_EVENT_TYPES = [enums_1.AuditLogEventType.CreateSimulatedPerson, enums_1.AuditLogEventType.UpdateSimulatedPerson, enums_1.AuditLogEventType.DeleteSimulatedPerson];
//# sourceMappingURL=simulated-person-audit.js.map